import Vue from 'vue'
import Router from 'vue-router'
import $store from '@/store'
import {readLocal} from '@/assets/js/common'

import Assist from '@/components/assist/index' // 辅助界面
import Login from '@/components/assist/login/index' // 辅助界面 --- 登录
import Forget from '@/components/assist/forget/index' // 辅助界面 --- 忘记密码
import main from '@/components/main/index' // 主界面
import apply from '@/components/main/apply' // 申请管理
import times from '@/components/main/times' // 多次申请管理
import role from '@/components/main/role' // 管理员管理
import param from '@/components/main/param' // 参数管理
import school from '@/components/main/school' // 学校管理
import importPage from '@/components/main/importPage' // 导入
import previous from '@/components/main/previous' // 往届申请管理
import previousDesc from '@/components/main/desc' // 申请详情
import importStudent from '@/components/main/importStudent' // 导入学生
import notice from '@/components/main/notice' // 通知
import noticeAction from '@/components/main/noticeAction' // 通知

Vue.use(Router)

if (readLocal('userToken', 'token')) {
  $store.commit('setToken', readLocal('userToken', 'token'))
}

let constantRouterMap = [
  {
    path: '/assist',
    component: Assist,
    children: [
      {
        path: 'login',
        component: Login
      },
      {
        path: 'forget',
        component: Forget
      }
    ],
    redirect: '/assist/login'
  },
  {
    path: '/login',
    redirect: '/assist/login'
  }
]

let syncRouters = userInfo => {
  let routes = []
  let routerList = [
    {
      path: '/',
      component: main,
      children: [
        {
          path: 'apply',
          component: apply,
          meta: {menu: [1, 2, 3]}
        },
        {
          path: 'role',
          component: role,
          meta: {menu: [1, 2]}
        },
        {
          path: 'times',
          component: times,
          meta: {menu: [1, 2]}
        },
        {
          path: 'param',
          component: param,
          meta: {menu: [1, 2]}
        },
        {
          path: 'school',
          component: school,
          meta: {menu: [1, 2, 3]}
        },
        {
          path: 'import',
          component: importPage
        },
        {
          path: 'previous',
          component: previous,
          meta: {menu: [1, 2]}
        },
        {
          path: 'previousDesc/:id',
          name: 'previousDesc',
          component: previousDesc,
          meta: {menu: [1, 2]}
        },
        {
          path: 'notice',
          component: notice,
          meta: {menu: [1, 2]}
        },
        {
          path: 'notice/action',
          component: noticeAction,
          name: 'noticeAction',
          meta: {menu: [1, 2]}
        },
        {
          path: 'notice/action/:id',
          component: noticeAction,
          name: 'noticeActionEdit',
          meta: {menu: [1, 2]}
        },
        {
          path: 'importStudent',
          component: importStudent
        }
      ]
    }
  ]
  let filterRouters = arr => {
    let role = userInfo['role']
    let pos = route => {
      if (route.meta && route.meta['menu']) {
        return route.meta.menu.indexOf(role) !== -1
      } else {
        return true
      }
    }
    routes = arr.filter(o => {
      if (pos(o)) {
        if (o.children && o.children.length > 0) {
          o.children = o.children.filter(child => {
            if (pos(child)) {
              return child
            }
            return false
          })
          return o
        } else {
          return o
        }
      } else {
        return false
      }
    })
  }
  filterRouters(routerList)
  if (routes[0].children.length > 0) {
    routes[0]['redirect'] = '/' + routes[0]['children'][0]['path']
  }
  routes.push({path: '*', redirect: '/'})
  return routes
}

const createRouter = () => new Router({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: '',
  routes: constantRouterMap
})

const router = createRouter()

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

router.beforeEach((to, from, next) => {
  if (to.path.indexOf('/assist') >= 0) { // 非验证页面
    if (to.matched.length === 0) {
      from.path ? next({path: from.path}) : next('/')
    } else {
      next()
    }
  } else {
    if ($store.state.base.token) {
      if ($store.state.base.userInfo) {
        next()
      } else {
        $store.dispatch('getUserInfo').then(res => {
          resetRouter()
          router.addRoutes(syncRouters(res))
          next({...to, replace: true})
        }).catch(err => {
          console.log(err)
        })
      }
    } else {
      next({path: '/assist/login'})
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js